module.exports = __webpack_public_path__ + "img/kankou_25.8fe818c9.jpg";